/**
 * UI slice — language, theme, and other UI preferences.
 */

import { createSlice } from '@reduxjs/toolkit';
import { storageGet, storageSet, STORAGE_KEYS } from '@/utils/storage';

const DEFAULT_LANGUAGE = import.meta.env.VITE_DEFAULT_LANGUAGE || 'fa';

const initialState = {
  /** @type {'fa'|'en'} */
  language: storageGet(STORAGE_KEYS.LANGUAGE, DEFAULT_LANGUAGE),
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    /**
     * Set UI language. Persists to localStorage.
     * @param {'fa'|'en'} language
     */
    setLanguage(state, action) {
      state.language = action.payload;
      storageSet(STORAGE_KEYS.LANGUAGE, action.payload);
    },
  },
});

export const { setLanguage } = uiSlice.actions;

export default uiSlice.reducer;

// Selectors
export const selectLanguage = (state) => state.ui.language;
export const selectIsRtl = (state) => state.ui.language === 'fa';
